import http from "../http-common";

class MonitoringNumberService {
  create_monitoring_number(data) {
    return http.post(`/monitoring_number`, data);
  }
  getmonitoring_numbers() {
    return http.get(`/monitoring_number`);
  }
  get_monitoring_number(id) {
    return http.get('/monitoring_number/' + id);
  }
  updatemonitoring_number(id, data) {    
    return http.put(`/monitoring_number/${id}`, data);
  }
  deleteteacher(id) {
    return http.delete('/monitoring_number/' + id);
  }
}

export default new MonitoringNumberService();